<template>
  <div class="animated fadeIn">
    <div class="card">
      <!-- <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} phản hồi</span>
        <span v-if="mData.viewMode == 'updateTcqltt'">{{aLang.c_changeStatus}} xử lý phản hồi</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} phản hồi</span>
        <div class="card-header-actions"></div>
      </div>-->
      <div class="card-body">
        <el-form
          :model="mData.dataFormOther"
          :rules="mData.validFormOther"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item
                label="Người xử lý hiện tại"
                prop="nguoi_xu_ly_hien_tai"
              >
                <el-input
                  type="text"
                  v-model="mData.dataFormOther.nguoi_xu_ly_hien_tai"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6" v-if="this.componentProps.allowSend">
              <el-form-item label="Trạng thái xử lý" prop="trang_thai_chuyen">
                <el-select
                  :placeholder="aLang.c_select"
                  v-model="mData.dataFormOther.trang_thai_chuyen"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="false"
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThaiChuyen"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6" v-if="!this.componentProps.allowSend">
              <el-form-item label="Trạng thái xử lý" prop="trang_thai_chuyen">
                <el-select
                  :placeholder="aLang.c_select"
                  v-model="mData.dataFormOther.trang_thai_chuyen"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="false"
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.trangThaiXL"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item
                label="Nội dung hồi đáp người phản ánh"
                prop="lich_su.noi_dung_hoi_dap"
              >
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="mData.dataFormOther.lich_su.noi_dung_hoi_dap"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item
                class="mb-1"
                label="File đính kèm hồi đáp người phản ánh"
              >
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="text"
                  :limit="
                    mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.limit
                  "
                  :accept="
                    mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.accept
                  "
                  :on-change="fn_uploadChangeFileDinhKemGuiNguoiPhanAnh"
                  :on-preview="fn_uploadPreviewFileDinhKemGuiNguoiPhanAnh"
                  :on-remove="fn_uploadRemoveFileDinhKemGuiNguoiPhanAnh"
                  :on-exceed="fn_uploadExceedFileDinhKemGuiNguoiPhanAnh"
                  multiple
                  :file-list="
                    mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.fileList
                  "
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-button
                    size="small"
                    type="primary"
                    :disabled="mData.viewMode == 'detail'"
                    >Chọn tệp</el-button
                  >
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="
                    mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh
                      .dialogVisible
                  "
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="
                      mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh
                        .dialogImageUrl
                    "
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row> </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung xử lý" prop="noi_dung_xu_ly">
                <el-input
                  type="textarea"
                  rows="3"
                  v-model="mData.dataFormOther.lich_su.noi_dung_xu_ly"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item class="mb-0" label="File đính kèm">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="text"
                  :limit="mData.fileUploadOption.FileDinhKemTCQLTT.limit"
                  :accept="mData.fileUploadOption.FileDinhKemTCQLTT.accept"
                  :on-change="fn_uploadChangeFileDinhKemTCQLTT"
                  :on-preview="fn_uploadPreviewFileDinhKemTCQLTT"
                  :on-remove="fn_uploadRemoveFileDinhKemTCQLTT"
                  :on-exceed="fn_uploadExceedFileDinhKemTCQLTT"
                  multiple
                  :file-list="mData.fileUploadOption.FileDinhKemTCQLTT.fileList"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-button
                    size="small"
                    type="primary"
                    :disabled="mData.viewMode == 'detail'"
                    >Chọn tệp</el-button
                  >
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="
                    mData.fileUploadOption.FileDinhKemTCQLTT.dialogVisible
                  "
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="
                      mData.fileUploadOption.FileDinhKemTCQLTT.dialogImageUrl
                    "
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('updateTangThai')"
              v-ladda
              >{{ aLang.c_update }}</el-button
            >

            <!-- <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../service/LanguageService";
import DataService from "../service/DataService";
import MethodService from "../service/MethodService";
import ExtensionService from "../service/ExtensionService";
import PhanHoiModel from "../views/admin/PhanHoi/PhanHoiModel";
import PhanHoiApi from "../moduleApi/PhanHoiApi";
import ProfileApi from "@/moduleApi/ProfileApi";
import CauHinhApi from "@/moduleApi/CauHinhApi";
import FileApi from "@/moduleApi/FileApi";

export default {
  props: {
    componentProps: {
      id: String,
      mode: String,
      allowSend: Boolean,
    },
    close: Boolean,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "PhanHoi",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listNguoiGuiPhanHoi: [],
          listNhomPhanHoi: [],
          listLichSu: [],
          listDoiTuongPhanHoi: MethodService.copyObject(
            PhanHoiModel.doiTuongPhanHoi
          ),
          trangThai: PhanHoiModel.trangThai,
          trangThaiChuyen: PhanHoiModel.trangThaiChuyen,
          trangThaiXL: DataService.trangThaiXL,
          listNguoiDung: [],
        },
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        dataFormOther: MethodService.copyObject(PhanHoiModel.dataFormOthers),
        validForm: PhanHoiModel.validForm,
        validFormOther: PhanHoiModel.validFormOther,
        fileUploadOption: MethodService.copyObject(
          PhanHoiModel.dataFormOthers.fileUploadOption
        ),
        dialog: {},
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        let dataOther = this.mData.dataFormOther.lich_su;
        try {
          if (!valid) {
            return;
          } else {
            if (
              this.mData.dataFormOther.trang_thai_chuyen ==
              "forwarded_to_tcqltt"
            ) {
              let resNguoiXuLyTCQLTT = await CauHinhApi.list({
                filters: "code:in:default_user_tcqltt_id",
              });
              if (
                !resNguoiXuLyTCQLTT ||
                !resNguoiXuLyTCQLTT.result ||
                resNguoiXuLyTCQLTT.result.length === 0
              ) {
                return;
              }
              this.mData.dataDefault.nguoiXuLyTCQLTT =
                resNguoiXuLyTCQLTT.result[0].value;

              let lichSuItem = MethodService.copyObject(
                PhanHoiModel.dataFormOther.lich_su
              );
              lichSuItem.tu = this.mData.currentUser.id;
              lichSuItem.den = this.mData.dataDefault.nguoiXuLyTCQLTT;
              lichSuItem.ly_do =
                "Hệ thống chuyển phản hồi tới tổng cục quản lý thị trường";
              lichSuItem.thoi_diem = new Date();
              lichSuItem.trang_thai = "new";
              let tcqlttItem = MethodService.copyObject(
                PhanHoiModel.dataFormOther.tcqltt
              );
              tcqlttItem.nguoi_xu_ly_id =
                this.mData.dataDefault.nguoiXuLyTCQLTT;
              tcqlttItem.trang_thai = "new";
              if (
                this.mData.dataForm.tcqltt &&
                this.mData.dataForm.tcqltt.lich_su.length > 0
              ) {
                tcqlttItem.lich_su = [...this.mData.dataForm.tcqltt.lich_su];
              }
              tcqlttItem.lich_su.push(lichSuItem);

              let data = {
                id: this.componentProps.id,
                trang_thai: "forwarded_to_tcqltt",
                tcqltt: tcqlttItem,
              };
              // BE tự gửi mail trong PhanHoiApi.updateSend, FE không gọi sendEmail nữa
              await PhanHoiApi.updateSend(data);
            } else {
              dataOther.trang_thai = this.mData.dataFormOther.trang_thai_chuyen;
              dataOther.id = this.componentProps.id;
              dataOther.noi_dung_hoi_dap =
                this.mData.dataFormOther.lich_su.noi_dung_hoi_dap;
              dataOther.noi_dung_xu_ly =
                this.mData.dataFormOther.lich_su.noi_dung_xu_ly;
              delete dataOther.trang_thai_sau;
              delete dataOther.trang_thai_truoc;
              await PhanHoiApi.updateStatus(dataOther);
            }
          }
          window.location.reload();
        } finally {
          MethodService.stopLadda();
        }
      });
    },
    fn_resetForm() {
      this.mData.fileUploadOption = MethodService.copyObject(
        PhanHoiModel.dataFormOthers.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await PhanHoiApi.findById(id);
      this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.fileList = [];
      this.mData.fileUploadOption.FileDinhKemTCQLTT.fileList = [];
      if (res.result) {
        const profileApiRes = await ProfileApi.findById(
          this.mData.currentUser.id
        );
        if (profileApiRes.result) {
          if (
            profileApiRes.result.ho_ten &&
            profileApiRes.result.ho_ten.ho_ten &&
            profileApiRes.result.ho_ten.ho_ten.trim() != ""
          ) {
            this.mData.dataFormOther.nguoi_xu_ly_hien_tai =
              profileApiRes.result.ho_ten.ho_ten;
          } else {
            this.mData.dataFormOther.nguoi_xu_ly_hien_tai = "Chưa có thông tin";
          }
        }
        this.mData.dataFormOther.trang_thai_chuyen = res.result.trang_thai;
        // if(res.result.lich_su){
        //   let a = res.result.lich_su.length - 1;
        //   this.mData.dataFormOther.lich_su = res.result.lich_su[a];
        //   if(res.result.lich_su[a].file_hoi_dap_ids){
        //     let listFile = await FileApi.list({
        //       limit: res.result.lich_su[a].file_hoi_dap_ids.length,
        //       filters: "id:in:" + res.result.lich_su[a].file_hoi_dap_ids.join(",")
        //     });
        //     let data = [];
        //     if (listFile && listFile.result) {
        //       data = listFile.result;
        //       data.map(item => {
        //         item.url = ExtensionService.urlImg + item.id;
        //       });
        //     }
        //     this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.fileList = data;
        //   }
        //   if(res.result.lich_su[a].file_xu_ly_ids){
        //     let listFile = await FileApi.list({
        //       limit: res.result.lich_su[a].file_xu_ly_ids.length,
        //       filters: "id:in:" + res.result.lich_su[a].file_xu_ly_ids.join(",")
        //     });
        //     let data = [];
        //     if (listFile && listFile.result) {
        //       data = listFile.result;
        //       data.map(item => {
        //         item.url = ExtensionService.urlImg + item.id;
        //       });
        //     }
        //     this.mData.fileUploadOption.FileDinhKemTCQLTT.fileList = data;
        //   }
        // }
        this.mData.dataForm = res.result;
      }
    },
    async fn_initDataDefault() {},

    fn_uploadRemoveFileDinhKemTCQLTT(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataFormOther.lich_su.file_xu_ly_ids = data;
    },
    fn_uploadRemoveFileDinhKemGuiNguoiPhanAnh(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataFormOther.lich_su.file_hoi_dap_ids = data;
    },
    fn_uploadChangeFileDinhKemTCQLTT(file, fileList) {
      // debugger
      ExtensionService.upload(file, "phanHoiTcqltt")
        .then((res) => {
          // debugger
          if (
            this.mData.dataFormOther.lich_su &&
            this.mData.dataFormOther.lich_su.file_xu_ly_ids
          ) {
            this.mData.dataFormOther.lich_su.file_xu_ly_ids.push(res.result);
          } else {
            this.mData.dataFormOther.lich_su.file_xu_ly_ids = [];
            this.mData.dataFormOther.lich_su.file_xu_ly_ids.push(res.result);
          }
          // this.mData.dataFormOther.lich_su.file_dinh_kem.push(res.result);

          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          // debugger
          this.mData.fileUploadOption.FileDinhKemTCQLTT.fileList = [];
          this.mData.fileUploadOption.FileDinhKemTCQLTT.fileList = fileList;
        })
        .catch((error) => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadChangeFileDinhKemGuiNguoiPhanAnh(file, fileList) {
      // debugger
      ExtensionService.upload(file, "phanHoi")
        .then((res) => {
          // debugger
          if (
            this.mData.dataFormOther.lich_su &&
            this.mData.dataFormOther.lich_su.file_hoi_dap_ids
          ) {
            this.mData.dataFormOther.lich_su.file_hoi_dap_ids.push(res.result);
          } else {
            this.mData.dataFormOther.lich_su.file_hoi_dap_ids = [];
            this.mData.dataFormOther.lich_su.file_hoi_dap_ids.push(res.result);
          }
          // this.mData.dataFormOther.lich_su.file_dinh_kem.push(res.result);

          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          // debugger
          this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.fileList = [];
          this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.fileList =
            fileList;
        })
        .catch((error) => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedFileDinhKemTCQLTT(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKemTCQLTT.limit} file`
      );
    },
    fn_uploadExceedFileDinhKemGuiNguoiPhanAnh(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.limit} file`
      );
    },
    fn_uploadPreviewFileDinhKemTCQLTT(file) {
      this.mData.fileUploadOption.FileDinhKemTCQLTT.dialogImageUrl = file.url;
      this.mData.fileUploadOption.FileDinhKemTCQLTT.dialogVisible = true;

      // window.open(ExtensionService.urlFile + file.id);
    },
    fn_uploadPreviewFileDinhKemGuiNguoiPhanAnh(file) {
      this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.dialogImageUrl =
        file.url;
      this.mData.fileUploadOption.FileDinhKemGuiNguoiPhanAnh.dialogVisible = true;

      // window.open(ExtensionService.urlFile + file.id);
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_init() {
      this.fn_initDataDefault();
      if (this.componentProps.mode == "update") {
        this.mData.viewMode = "update";
      }
      if (this.componentProps.mode == "updateTcqltt") {
        this.mData.viewMode = "updateTcqltt";
      }
      if (this.componentProps.mode == "updateTrangThai") {
        this.mData.viewMode = "updateTrangThai";
      }
      if (this.componentProps.mode == "detail") {
        this.mData.viewMode = "detail";
      }
      if (this.componentProps.id) {
        this.fn_getDataById(this.componentProps.id);
      }
    },
  },
  created: function () {
    this.fn_init();
  },
  mounted: function () {},
  watch: {
    componentProps: function () {
      this.fn_init();
    },
    close: function () {
      if (this.close) {
        console.log("asss");
      }
    },
  },
};
</script>
